<template>
  <div id="setting-screen" class="mt-0">
    <v-tabs :value="currentTabIndex" @change="changeTab" background-color="transparent" class="bg-white mb-4 rounded">
      <v-tab v-for="tabItem in tabs" :tabindex="tabItem.index" :key="tabItem.index"
        @click="loadRoute(tabItem.routeName)">{{ tabItem.label }}</v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("_SALE_PACKAGE.SALE_PACKAGE") + ' - ' + this.$t('CHAIN'),
          routeName: "chain-rate-plan",
          roles: ["CHAIN_RATE_PLAN"],
        },
        {
          index: 1,
          label: this.$t("_SALE_PACKAGE.RATE_CATEGORY") + ' - ' + this.$t('CHAIN'),
          routeName: "ChainRateCategorys",
          roles: ["CHAIN_RATE_PLAN"],
        },
      ],
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    switch (this.$route.name) {
      case "chain-rate-plan-infomation":
      case "chain-rate-plan":
        this.currentTabIndex = 0;
        break;
      case "ChainRateCategoryDetail":
      case "ChainRateCategorys":
        this.currentTabIndex = 1;
        break;
    }
  },
  watch: {
    $route(value) {
      switch (this.$route.name) {
        case "chain-rate-plan-infomation":
        case "chain-rate-plan":
          this.currentTabIndex = 0;
          break;
        case "ChainRateCategoryDetail":
        case "ChainRateCategorys":
          this.currentTabIndex = 1;
          break;
      }
    },
  },
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
